

document.addEventListener('sealsubs:subscription_widget_created', function(e) {
	updateSealPrice()
});
document.addEventListener('sealsubs:price_update', function(e) {
	updateSealPrice()
});
document.addEventListener('sealsubs:selling_plan_changed', function(e) {
	updateSealPrice()
});

function updateSealPrice() {
  setTimeout(() => {
    const priceContainer = document.querySelector('.sls-price .seal-money');
    const newPriceElement = document.querySelector('.main-product-price .price-sale');
    const discountedPrice = document.querySelector('.main-product-price small');

    if (priceContainer && newPriceElement && discountedPrice) {
      priceContainer.textContent = newPriceElement.textContent;
      console.log('Price updated successfully');
    }
  }, 600)
}

function initCartAlsoLikeSlider() { //called in x-intersect
  console.log('drawer script...')
  const collecSwiper = document.querySelector('.cart_also_like_collection')
  console.log("collecSwiper", collecSwiper)
  new Swiper(".cart_also_like_collection", {
    loop: false,
    navigation: {
      nextEl: '.cart-also-like-navigation .swiper-button-next',
      prevEl: '.cart-also-like-navigation .swiper-button-prev',
    },
    on: {
      init: function () {
        console.log('swiper initialized');
      },
    },
    slidesPerView: 1.8, // number of slides visible
    spaceBetween: 15, // space between slides in px
    breakpoints: {
      640: {
        slidesPerView: 2.2,
        spaceBetween: 20
      }
    }
  });
}

document.addEventListener('DOMContentLoaded', function () {
  
})

document.addEventListener('DOMContentLoaded', function () {
    const scrollingPromotions = document.querySelectorAll('.section-scroll-banner .open-alia-campaign')
    scrollingPromotions.forEach(el => {
        el.addEventListener('click', function(e) {
            const aliaCampaignId = this.dataset.aliaCampaignId
            if(aliaCampaignId){
                e.preventDefault()
                openAliaCampaign(aliaCampaignId)
            }
        })
    });

    const aliaButtons = document.querySelectorAll('.image-with-text .open-alia-campaign')
    aliaButtons.forEach(el => {
        el.addEventListener('click', function(e) {
            const aliaCampaignId = this.dataset.aliaCampaignId
            if(aliaCampaignId){
                e.preventDefault()
                openAliaCampaign(aliaCampaignId)
            }
        })
    });

    function openAliaCampaign(campaignID) {
        if(!campaignID) return
        window.alia = window.alia || [];
        window.alia.push({ 
            type: "open", 
            campaignID: parseInt(campaignID),
            ignoreTargeting: true
        })
    }
})

document.addEventListener("DOMContentLoaded", function () {
  const toggle = document.querySelector("#mobile-nav");
  const menuMobile = document.querySelector(".menu-mobile");
  const menuInner = document.querySelector(".mobile-menu-inner");

  if (toggle && menuMobile && menuInner) {
    toggle.addEventListener("click", function (e) {
      e.stopPropagation(); 
      document.body.classList.toggle("mobile-nav-open");

      const rootStyles = getComputedStyle(document.documentElement);
      const heightHeader = parseInt(rootStyles.getPropertyValue("--height-header")) || 0;
      const topHeader = parseInt(rootStyles.getPropertyValue("--top-header")) || 0;
      const scrollbarWidth = parseInt(rootStyles.getPropertyValue("--width-scrollbar")) || 0;

      const menuHeight = window.innerHeight - heightHeader - topHeader;
      menuMobile.style.height = `${menuHeight}px`;
      menuMobile.style.paddingRight = `${scrollbarWidth}px`;

      if (document.body.classList.contains("mobile-nav-open")) {
        if (toggle.closest(".sticky-header-active")) {
          menuMobile.classList.add("from-header-up");
        }
      } else {
        menuMobile.classList.remove("from-header-up");
      }
    });

    document.addEventListener("click", function (e) {
      if (
        document.body.classList.contains("mobile-nav-open") &&
        !menuInner.contains(e.target) &&
        !toggle.contains(e.target)
      ) {
        document.body.classList.remove("mobile-nav-open");
        menuMobile.classList.remove("from-header-up");
      }
    });
  }
});



document.addEventListener("click", function(e) {
    if (e.target.closest(".submenu-toggle")) {
      const btn = e.target.closest(".submenu-toggle");
      const parentLi = btn.closest("li");
      parentLi.classList.add("submenu-open");
    }
    if (e.target.closest(".back-menu")) {
      const back = e.target.closest(".back-menu");
      const parentUl = back.closest(".submenu");
      const parentLi = parentUl.closest("li");
      parentLi.classList.remove("submenu-open");
    }
  });


document.addEventListener("DOMContentLoaded", () => {
  const menuItems = document.querySelectorAll(".action-click");

  if (!menuItems.length) return;

  menuItems.forEach((item) => {
    // click on the action-click itself
    item.addEventListener("click", (e) => {
      const menuWrapper = item.querySelector(".mega-menu-wrapper-outer");
      if (!menuWrapper) return;

      // prevent outside click handler from firing immediately
      e.stopPropagation();

      // Close other menus
      menuItems.forEach((otherItem) => {
        if (otherItem !== item) {
          otherItem.classList.remove("active");
          const otherMenu = otherItem.querySelector(".mega-menu-wrapper-outer");
          if (otherMenu) otherMenu.classList.remove("active");
        }
      });

      // Toggle current
      item.classList.toggle("active");
      menuWrapper.classList.toggle("active");
    });
  });

  // Prevent menu from closing when clicking inside it
  document.querySelectorAll(".mega-menu-wrapper-outer").forEach((menu) => {
    menu.addEventListener("click", (e) => {
      e.stopPropagation();
    });
  });

  // Close menu only when clicking completely outside
  document.addEventListener("click", () => {
    menuItems.forEach((item) => {
      item.classList.remove("active");
      const menuWrapper = item.querySelector(".mega-menu-wrapper-outer");
      if (menuWrapper) menuWrapper.classList.remove("active");
    });
  });
});




document.addEventListener("DOMContentLoaded", () => {
  const alphabetBtns = document.querySelectorAll(".alpha");
  const items = document.querySelectorAll(".brand-menu .menga-menu-lik-list li");

  alphabetBtns.forEach(btn => {
    btn.addEventListener("click", () => {
      const letter = btn.dataset.letter.toLowerCase();

      // Toggle clicked button
      btn.classList.toggle("active");

      // Optional: remove active from other buttons
      alphabetBtns.forEach(b => {
        if (b !== btn) b.classList.remove("active");
      });

      items.forEach(item => {
        const text = item.textContent.trim().toLowerCase();
        const firstChar = text.charAt(0);

        if (letter === "all") {
          item.classList.remove("faded", "highlighted");
        } else if (firstChar === letter) {
          item.classList.add("highlighted");
          item.classList.remove("faded");
        } else {
          item.classList.remove("highlighted");
          item.classList.add("faded");
        }
      });
    });
  });
});

document.addEventListener('DOMContentLoaded', function() {
  document.body.addEventListener('click', function(e) {
    const target = e.target.closest('.header__menu-item[mainMenuList]');
    if (target) {
      // pehle saare activeList remove kar do
      document.querySelectorAll('.header__menu-item[mainMenuList]').forEach(item => {
        const parentLi = item.closest('li');
        if (parentLi) parentLi.classList.remove('activeList');
      });

      // clicked wale li ko add karo
      const parentLi = target.closest('li');
      if (parentLi) {
        parentLi.classList.add('activeList');
      }
    }
  });
});

document.body.addEventListener('click', function(e) {
  if (e.target.id === 'MainContent' || e.target.closest('#MainContent div') || e.target.closest('.top-header') || e.target.closest('.header-bottom')) {
    document.querySelectorAll('.activeList').forEach(el => {
      el.classList.remove('activeList');
    });
  }
});

document.addEventListener("product_init", () => {
  const prodDescReadMoreBtn = document.querySelector(".product-content-container .desc_read_more")
  console.log("prodDescReadMoreBtn", prodDescReadMoreBtn)
  if(prodDescReadMoreBtn) {
    prodDescReadMoreBtn.addEventListener('click', function() {
      const overviewCont = document.querySelector('#overview-content')
      if(overviewCont) {
        if(window.tabManager.showTab) window.tabManager.showTab("overview");
        overviewCont.scrollIntoView({ behavior: 'smooth' })
      }
    })
  }
});


document.addEventListener('DOMContentLoaded', function() {
    const descReadMoreButtons = document.querySelectorAll('.desc_read_moress');
    descReadMoreButtons.forEach(function(button) {
        button.addEventListener('click', function() {
            const productDesc = this.closest('.product-short-description');
            
            if (productDesc) {
                productDesc.classList.add('expanded');
                productDesc.classList.add('mob_hide');
            }
        });
    });
}); 




// document.addEventListener('DOMContentLoaded', function() {
//   const readMoreButtons = document.querySelectorAll('.desc_read_moress');
//   const readLessButtons = document.querySelectorAll('.desc_read_less');

//   // Sirf ek element ke liye smooth slide (show animation only)
//   function smoothShow(el, duration = 400) {
//     el.style.display = 'block';
//     el.style.overflow = 'hidden';
//     const height = el.scrollHeight;
//     el.style.height = '0px';
//     el.style.opacity = '0';

//     const startTime = performance.now();

//     function animate(time) {
//       const progress = Math.min((time - startTime) / duration, 1);
//       const eased = 0.5 - Math.cos(progress * Math.PI) / 2;

//       el.style.height = height * eased + 'px';
//       el.style.opacity = eased;

//       if (progress < 1) {
//         requestAnimationFrame(animate);
//       } else {
//         el.style.height = 'auto';
//         el.style.opacity = '1';
//         el.style.overflow = '';
//       }
//     }

//     requestAnimationFrame(animate);
//   }

//   // Read More
//   readMoreButtons.forEach(btn => {
//     btn.addEventListener('click', function() {
//       const productDesc = this.closest('.product-short-description');
//       const shortDesc = productDesc.querySelector('.mineDesc');
//       const fullDesc = productDesc.querySelector('.mineDescFull');

//       // Short desc ko direct hide kar do (no animation)
//       shortDesc.style.display = 'none';

//       // Sirf fullDesc pe smooth show transition
//       smoothShow(fullDesc, 500);

//       this.style.display = 'none';
//       productDesc.querySelector('.desc_read_less').style.display = 'inline';
//     });
//   });
// });




document.addEventListener("click", async (e) => {
  const button = e.target.closest(".add_to_advanced");
  if (!button) return;
  e.preventDefault();
  const variantId = button.dataset.variantId;
  if (!variantId) {
    alert("Variant ID not found.");
    return;
  }
  const itemsToAdd = [
    {
      id: parseInt(variantId),
      quantity: 1,
    },
  ];

  try {
    await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: itemsToAdd }),
    });

    const cartResponse = await fetch("/cart.js");
    const cart = await cartResponse.json();

    const countBubble = document.querySelector(".header__count-bubble span");
    if (countBubble) countBubble.textContent = cart.item_count || 0;

    const cartDrawer = document.querySelector("#cart-drawer");
    if (cartDrawer) {
      cartDrawer.classList.remove("is-empty");
      cartDrawer.classList.add("active");

      if (
        typeof window.CartDrawer !== "undefined" &&
        window.CartDrawer.renderContents
      ) {
        window.CartDrawer.renderContents(cart);
      }
    } else if (typeof window.xProductCart === "function") {
      window.xProductCart();
    }

    if (window.Alpine && Alpine.store("xMiniCart")) {
      Alpine.store("xMiniCart").reLoad();
      setTimeout(() => {
        Alpine.store("xMiniCart").openCart();
      }, 300);
    }

  } catch (err) {
    console.error("Error adding product:", err);
    alert("Something went wrong. Please try again.");
  }
});



document.addEventListener("DOMContentLoaded", () => {
  const searchInput = document.querySelector("#search-in-modal");
  const searchResult = document.querySelector("#search-result");
  if (!searchInput) return;

  function clearSearchInput() {
    searchInput.value = "";

    if (searchResult) {
      searchResult.innerHTML = "";
    }

    const event = new KeyboardEvent("keyup", { bubbles: true, cancelable: true });
    searchInput.dispatchEvent(event);
  }

  document.addEventListener("click", (e) => {
    const clickedInside =
      e.target.closest("#search-in-modal") ||
      e.target.closest(".predictive-search") ||
      e.target.closest("form.search") ||
      e.target.closest(".btn-search")||
      e.target.closest("#pop_search_cust");

    if (clickedInside) return;

    clearSearchInput();
  });
});




document.addEventListener('DOMContentLoaded', () => {
  try {
    const checkboxes = document.querySelectorAll('.fbt-product-checkbox');
    const checkboxes_img = document.querySelectorAll('.routine_inner_container');
    const atcBtn = document.querySelector('.freq-atc-btn');

    if (!checkboxes || !checkboxes_img || !atcBtn) {
      console.warn('Required elements not found in the DOM.');
      return;
    }

    function toggleButtonState() {
      try {
        const anyChecked = Array.from(checkboxes).some(cb => cb.checked);

        if (!anyChecked) {
          atcBtn.setAttribute('disabled', true);
          atcBtn.classList.add('disabled');
        } else {
          atcBtn.classList.remove('disabled');
          atcBtn.removeAttribute('disabled');
        }
      } catch (error) {
        console.error('Error in toggleButtonState:', error);
      }
    }

    // Initial check
    toggleButtonState();

    // Event listeners
    checkboxes_img.forEach(cb => {
      cb.addEventListener('click', () => {
        setTimeout(() => {
          try {
            toggleButtonState();
          } catch (error) {
            console.error('Error while toggling state on click:', error);
          }
        }, 100);
      });
    });

  } catch (error) {
    console.error('Error initializing checkbox logic:', error);
  }
});


document.addEventListener('DOMContentLoaded', () => {
  $('body').on('click', '#SearchOpenMobile', function(){
    setTimeout(function(){
      $('#form-search-header-search-block input[name="q"]').focus();
    }, 500);
  });

  $('body').on('click', '.desc_read_less', function () {
    try {
      const $parent = $(this).parents('.product-short-description');

      // Pehli baar click pe active class add kare
      if (!$parent.hasClass('active')) {
        $parent.addClass('active');
      } 
      // Agar already active hai (dusri click)
      else {
        //$parent.removeClass('active');

        const $target = $('.descriptionMine');
        if ($target.length) {
          // Smooth scroll kare agar element exist karta hai
          $('html, body').animate({
            scrollTop: $target.offset().top
          }, 600);
        } else {
          console.warn('DescriptionMine element not found for scrolling.');
        }
      }
    } catch (error) {
      console.error('Error in desc_read_less click handler:', error);
    }
  });


});

  

document.addEventListener("DOMContentLoaded", function () {
  const breadcrumbs = document.querySelectorAll(".br-ead-cr-umb");

  if (breadcrumbs.length > 1) {
    breadcrumbs.forEach((b, index) => {
      if (index !== 0) {
        b.style.display = "none";
      }
    });
  }
});


document.addEventListener("DOMContentLoaded", function () {
  const checkboxes = document.querySelectorAll(".fbt-product-checkbox");

  checkboxes.forEach(checkbox => {
    checkbox.checked = true;
  });
});

$(document).ready(function(){
  $('body').on('click', '.emailSharingBtn', function(){
    $('.shareEmailPop').removeClass('hide');
  });

  $('body').on('click', '.closeEmailPop', function(){
    $('.shareEmailPop').addClass('hide');
  });
  
  $('body').on('click', '.clientInfoButton', function(){
    $(this).addClass('active');
    var email = $(this).parent().find('input[name="clientEmail"]').val();
    var link = $(this).parent().find('input[name="permalinks"]').val();
    var doctor = link.split('doctor=')[1];
    var products = [];

    fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {

      products = cart.items.map(item => {

        const price = item.final_price / 100;
        const comparePrice = item.original_price / 100;

        let discount = '';

        if (comparePrice > price) {

          const discountPercent = Math.round(
            ((comparePrice - price) / comparePrice) * 100
          );

          discount = `${discountPercent}% OFF`;
        }

        return {

          title: item.product_title,

          doctor: item.vendor || 'Doctor Recommended',

          price: price,

          originalPrice: comparePrice > price
            ? comparePrice
            : '',

          discount: discount,

          image: item.image

        };

      });
    });

    setTimeout(function(){
      console.log(products);
      fetch('https://shopify-mail-api.vercel.app/api/send-cart-email', {

        method: 'POST',

        headers: {
          'Content-Type': 'application/json'
        },

        body: JSON.stringify({
          email: email,
          link: link,
          doctor: doctor,
          products: products
        })

      })

      .then(res => res.json())

      .then(data => {

        console.log(data);

        if (data.success) {
          $('.clientInfoButton').removeClass('active');
          $('.emailMessageSuccess').addClass('success');
          $('.emailMessageSuccess').html('Cart Link Shared !!');

          setTimeout(function(){

            $('.emailMessageSuccess').empty();
            $('.emailMessageSuccess').removeClass('success');
            $('.shareEmailPop').addClass('hide');

          }, 2000);

        } else {

          $('.emailMessageSuccess').addClass('fail');
          $('.emailMessageSuccess').html('Email Failed !!');

          setTimeout(function(){

            $('.emailMessageSuccess').empty();
            $('.emailMessageSuccess').removeClass('fail');
            $('.shareEmailPop').addClass('hide');

          }, 2000);

        }

      })

      .catch(error => {

        $('.emailMessageSuccess').addClass('fail');
        $('.emailMessageSuccess').html('Email Failed !!');

        setTimeout(function(){

          $('.emailMessageSuccess').empty();
          $('.emailMessageSuccess').removeClass('fail');
          $('.shareEmailPop').addClass('hide');

        }, 2000);

      });
    }, 2000);
  });
});
